<template>
  <router-link :to="`/legacydetails/${legacy?.id}`">
    <div class="w-full h-[1px] bg-line"></div>

    <div class="legacy-card group h-[250px] flex flex-col relative z-0">
      <div :style="`background:url(${legacy?.image})`" class="
          h-[250px]
          w-full
          legacy-img
          absolute
          opacity-0
          group-hover:opacity-90
          transition-all
          duration-500
        ">
        <div class="h-[250px] w-full bg-black bg-opacity-70"></div>
      </div>
      <div class="
          relative
          z-[1]
          group-hover:text-white
          flex
          items-center
          justify-between
          layout-padding
          h-full
        ">
        <div class="text-lg lg:flex hidden">{{ legacy?.year }}</div>
        <div class="lg:max-w-[25vw] md:max-w-[45vw] w-full">
          <div class="lg:text-3xl text-2xl lg:mb-4 uppercase truncate">{{ legacy?.title }}</div>
          <div class="text-lg flex mt-2 lg:hidden">{{ legacy?.year }}</div>
          <div class="text-lg flex md:hidden mb-2">{{ content[legacy?.type] }}</div>

          <div class="line-clamp-3 h-12 text-[#696969] group-hover:text-white legacy-card-desc" v-html="legacy?.description">

          </div>
        </div>
        <div class="text-lg md:flex hidden">{{ content[legacy?.type] }}</div>
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  props: ["legacy"],
  inject: ["content"],
};
</script>
